<script setup lang="ts">
import PhotoData from './wellbeing-sale--command.const'
import type { IPhotoWithDescriptionFields } from '@/types/contentful.ts'
import UiPhotoWithDescription from '@/components/UiPhotoWithDescription/UiPhotoWithDescription.vue'

const { uiPhotoData } = PhotoData()
</script>

<template>
  <div
    id="esg"
    class="commandCenter"
  >
    <div class="commandCenter__container">
      <h6 class="commandCenter__title">
        {{ $t('wellbeingSale.commandCenter.title') }}
      </h6>

      <UiPhotoWithDescription
        v-bind="uiPhotoData() as unknown as IPhotoWithDescriptionFields"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.commandCenter {
  padding: 5rem 1.6rem;
  background-color: $gray-100;
  
  &__container {
    max-width: 132rem;
    width: 90%;
    margin: auto;
  }

  &__title {
    @include h8;
    display: block;
    padding-bottom: 6.4rem;
    text-align: center;
  }

  :deep(.cf-photoWithDescription__contentText--big) {
    @include h8;
  }

  :deep(.cf-photoWithDescription__content:nth-of-type(2) .cf-photoWithDescription__contentText) {
    @include h10;
  }

  @include atM {
    padding: 10rem 0;

    &__title {
      @include h5;
      width: 80%;
      margin: auto;
    }

    :deep(.cf-photoWithDescription__contentText--big) {
      @include h8;
    }

    :deep(.cf-photoWithDescription__content:nth-of-type(2) .cf-photoWithDescription__contentText) {
      @include h10;
    }
  }

  @include atL {
    &__container {
      width: 100%;
    }
  }
}
</style>
